import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { JsonResponseModel } from '../../json-response.model';
import { DirectMessageModel } from '../models/direct-message.model';

const API_ENDPOINT = '/api/direct-message/';

@Injectable({
  providedIn: 'root',
})
export class DirectMessageService {

  /**
   * The constructor of the service
   *
   * @param http [http]
   */
  public constructor(private http: HttpClient) { }

  /**
   * Gets a list of messages by type
   *
   * @return Observable<JsonResponseModel<DirectMessageModel>
   */
  public getList(): Observable<JsonResponseModel<DirectMessageModel>> {
    return this.http.get<JsonResponseModel<DirectMessageModel>>(API_ENDPOINT + 'get/messages/coach')
      .pipe(
        map((response: JsonResponseModel<DirectMessageModel>) => {
          return response;
        }),
      );
  }
}
